import { DocumentTypeCat } from '@ps/platform-message-framework/common/DocumentTypeCat';
import { Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import React from 'react';
import { useField } from 'react-final-form';

import RMFDropDown from '../../../RMFDropDown/RMFDropDown';
import { docTypeField } from '../DocumentTypeField/DocumentTypeField';

import {
  TXTCLI_Council_Town_Hall,
  TXTCLI_Ministry_of_Transport,
  TXTCLI_Police_Authority___Prefettura,
  TXTCLI_Police_Authority___Questura,
  TXTCLI_Vehicle_Registration_Authority,
  TXTWCL_Enter_the_authority_who_issued_ELL,
  TXTWCL_Issuing_authority
} from './IssuingAuthorityField.messages.json';
import { label } from './IssuingAuthorityField.scss';

type DocType = Extract<
  DocumentTypeCat,
  | DocumentTypeCat.NATIONAL_IDENTITY_CARD
  | DocumentTypeCat.DRIVERS_LICENSE
  | DocumentTypeCat.PASSPORT
>;

const getOptions = (docType: DocType) => {
  const options = {
    [DocumentTypeCat.NATIONAL_IDENTITY_CARD]: [
      { text: <Translation {...TXTCLI_Council_Town_Hall} />, value: 1 }
    ],
    [DocumentTypeCat.DRIVERS_LICENSE]: [
      { text: <Translation {...TXTCLI_Ministry_of_Transport} />, value: 1 },
      { text: <Translation {...TXTCLI_Vehicle_Registration_Authority} />, value: 2 },
      { text: <Translation {...TXTCLI_Police_Authority___Prefettura} />, value: 3 }
    ],
    [DocumentTypeCat.PASSPORT]: [
      { text: <Translation {...TXTCLI_Police_Authority___Questura} />, value: 1 }
    ]
  } as const satisfies Record<
    DocType,
    {
      text: JSX.Element;
      value: number;
    }[]
  >;
  return options[docType];
};

const IssuingAuthorityField: React.FC = () => {
  const {
    input: { value: docType }
  } = useField(docTypeField, { subscription: { value: true } });
  const options = getOptions(docType);

  return (
    <RMFDropDown
      id="docIssuingAuthority"
      label={TXTWCL_Issuing_authority}
      options={options}
      validators={[required(TXTWCL_Enter_the_authority_who_issued_ELL)]}
      disabled={!docType || (docType && options.length < 2)}
      labelClassName={label}
    />
  );
};

export default IssuingAuthorityField;
